﻿import React from 'react';
import ReactDOM from 'react-dom';
import { parseDate } from '../../../../Resources/Scripts/_Shared/parseDate';
import Moment from 'moment';
import 'custom-event-polyfill';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

import controller from '../../../../Resources/Scripts/_Shared/controller';
import { DateSelection } from '../../../../Resources/Scripts/_Shared/form-date'

function landlordPermitsFilter(context) {
  const filtersDisabled = context.dataset.disabled && context.dataset.disabled === 'true';

  const placeSelect = context.querySelector(".landlordpermitspage__filter--place select");
  const profileSelect = context.querySelector(".landlordpermitspage__filter--profile select");
  const freeTextInput = context.querySelector(".landlordpermitspage__filter--text input");
  const startDateInput = context.querySelector(".landlordpermitspage__filter--startdate input");
  const endDateInput = context.querySelector(".landlordpermitspage__filter--enddate input");
  const sortSelect = context.querySelector(".landlordpermitspage__sort--order select");
  const filterWrapper = context.querySelector('.landlordpermitspage__filters');
  const showOldSwitch = context.querySelector('.landlordpermitspage__filter--switch input');

  let currentSortOrder = sortSelect.value;
  let ascendingOrder = true;
  let showOldSwitched = false;

  const listItemsWrapper = context.querySelector(".landlordpermitspage__list");
  const listItemsWrapperClone = listItemsWrapper.cloneNode(true);
  const countLabel = context.querySelector(".landlordpermitspage__sort__counter");

  const changeEvent = new CustomEvent('change');

  function init() {
    if (!filtersDisabled) {
      placeSelect.addEventListener('change', filter);
      profileSelect.addEventListener('change', filter);
      startDateInput.addEventListener('change', filter);
      endDateInput.addEventListener('change', filter);
      freeTextInput.addEventListener('keyup', debounce(filter, 300));
      sortSelect.addEventListener('change', () => filter('sort'));
      
      if (sortSelect.value || placeSelect.value.length > 0 || profileSelect.value.length > 0 || freeTextInput.value.length > 0 || startDateInput.value.length > 0 || endDateInput.value.length > 0) {
        filter();
      }

      addCustomDatePicker(startDateInput);
      addCustomDatePicker(endDateInput);

      //Disable enter in filter inputs
      ['keyup', 'keydown', 'keypress'].forEach(function (event) {
        filterWrapper.addEventListener(event, disableDefaultEnter);
      });
    }
  }

  function disableDefaultEnter(event) {
    if (event && event.key === 'Enter' && event.target.tagName !== 'SELECT' && event.target.tagName !== 'BUTTON') {
      if (event.target.name === 'showold' && !showOldSwitched) {
        const event = new Event('change');
        showOldSwitched = true;
        showOldSwitch.checked = !showOldSwitch.checked;
        showOldSwitch.dispatchEvent(event);
      }
      event.preventDefault();
    }
    return;
  }

  async function filter(eventType) {
    if (eventType === 'sort' && currentSortOrder === sortSelect.value) {
      ascendingOrder = !ascendingOrder;
    }
    else {
      currentSortOrder = sortSelect.value;
      if (currentSortOrder === 'valid-from' || currentSortOrder === 'valid-to') ascendingOrder = false;
      else ascendingOrder = true;
    }

    const placeAttribute = placeSelect.value.length === 0 ? '' : `[data-place="${placeSelect.value}"]`;
    const profileAttribute = profileSelect.value.length === 0 ? '' : `[data-profile="${profileSelect.value}"]`;
    const startDate = startDateInput.value.length === 0 ? null : parseDate(startDateInput.value);
    const endDate = endDateInput.value.length === 0 ? null : parseDate(endDateInput.value);
    const dateRange = moment.range(startDate, endDate);

    const listItemsToSearch = listItemsWrapperClone.cloneNode(true);
    const listItemsContainingValue = listItemsToSearch.querySelectorAll(`li${placeAttribute}${profileAttribute}`);

    listItemsWrapper.innerHTML = '';
    const newItemList = [];

    listItemsContainingValue.forEach((item, index) => {
      if (freeTextInput.value.length === 0 && !startDate && !endDate) {
        //listItemsWrapper.appendChild(item);
        newItemList.push({ element: item, noEnddate: !!(currentSortOrder === 'valid-to' && !item.dataset.enddate), sortvalue: getSortValue(item) })
        return;
      }

      const searchableContentNumber = item.querySelector('.left .number');
      const searchableContentName = item.querySelector('.middle .name') || item.querySelector('.middle span');
      const searchableContentLicenceplate = item.querySelector('.middle .licenceplate--content');
      const searchableContentText = searchableContentNumber?.innerText?.toUpperCase() + searchableContentName?.innerText?.toUpperCase() + searchableContentLicenceplate?.innerText.toUpperCase() + searchableContentLicenceplate?.innerText.toUpperCase().replace(/ /g, '');
      const itemStartDate = item.dataset.startdate && parseDate(item.dataset.startdate);
      const itemEndDate = item.dataset.enddate && parseDate(item.dataset.enddate);

      const textQuery = freeTextInput.value.toUpperCase();

      if (searchableContentText.indexOf(textQuery) !== -1 && (!startDate || !itemStartDate || dateRange.contains(itemStartDate)) && (!endDate || !itemEndDate || dateRange.contains(itemEndDate))) {
        //listItemsWrapper.appendChild(item);
        newItemList.push({ element: item, sortvalue: getSortValue(item) });
      }
    });

    sortAndAddElementsToContainer(newItemList, listItemsWrapper)
    countLabel.innerHTML = listItemsWrapper.childElementCount;

    listItemsWrapper.setAttribute('data-items', 10);
    freeTextInput.removeAttribute('aria-busy');
  }

  function getSortValue(element) {
    if (currentSortOrder === 'valid-from') {
      return parseDate(element.dataset.startdate).valueOf();
    }
    else if (currentSortOrder === 'valid-to') {
      return element.dataset.enddate ? parseDate(element.dataset.enddate).valueOf() : parseDate(element.dataset.startdate).valueOf();
    }
    else if (currentSortOrder === 'id-number') {
      return parseInt(element.querySelector('.left .number').innerText, 10);
    }
    else if (currentSortOrder === 'place') {
      return element.querySelector('.left .zone').innerText;
    }
    else {
      return '';
    }
  }

  function sortAndAddElementsToContainer(arr, container) {
    let sortedList = sortArray(arr);
    if (currentSortOrder === 'valid-to' && arr.some(item => item.noEnddate)) {
      const sortedListSortvalue = sortArray(sortedList.filter(item => !item.noEnddate));
      const sortedListNoEnddateSortvalue = sortArray(sortedList.filter(item => item.noEnddate));
      sortedList = ascendingOrder ? [...sortedListNoEnddateSortvalue, ...sortedListSortvalue] : [...sortedListSortvalue, ...sortedListNoEnddateSortvalue];
    }
    for (var i = 0; i < sortedList.length; i++) {
      container.appendChild(sortedList[i].element);
    }
  }
  function sortArray(arr) {
    return arr.sort((a, b) => {
      if (ascendingOrder)
        return a.sortvalue > b.sortvalue ? 1 : -1;

      return a.sortvalue > b.sortvalue ? -1 : 1;
    });
  }

  function addCustomDatePicker(existingPicker) {
    existingPicker.classList.add('hide');

    const appContainer = document.createElement('DIV');
    appContainer.classList.add('Form__DatePickerWrapper');
    insertAfter(appContainer, existingPicker);

    ReactDOM.render(<DateSelection existingPicker={existingPicker} locale={document.querySelector('html').getAttribute('country')} placeholder={existingPicker.placeholder} onChangeEvent={() => { existingPicker.dispatchEvent(changeEvent); }} showAllDates={true} />, appContainer);

    setTimeout(function() {
      const startDateVisibleInput = context.querySelector(".landlordpermitspage__filter--startdate .DayPickerInput input");
      startDateVisibleInput.addEventListener('keyup', function () { checkIfEmpty("startdate") });
      const endDateVisibleInput = context.querySelector(".landlordpermitspage__filter--enddate .DayPickerInput input");
      endDateVisibleInput.addEventListener('keyup', function () { checkIfEmpty("enddate") });
    }, 500);
  }

  function checkIfEmpty(date) {
    const startDateVisibleInput = document.querySelector(".landlordpermitspage__filter--startdate .DayPickerInput input").value;
    const endDateVisibleInput = document.querySelector(".landlordpermitspage__filter--enddate .DayPickerInput input").value;
    if ((date === "startdate" && startDateVisibleInput.length === 0) || (date === "enddate" && endDateVisibleInput.length === 0)) filter();
  };

  function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      freeTextInput.setAttribute('aria-busy', 'true');

      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  return {
    init
  };
}

controller.add('landlord-permits-filter', landlordPermitsFilter);